import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'

import FaClose from 'react-icons/fa/times-circle'
import FaCaretRight from 'react-icons/fa/caret-right'

import Recaptcha from 'react-google-invisible-recaptcha'

@autobind
class WorkShareByEmailModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      message: '',
      sending: false
    }
  }

  closeModal () {
    this.props.onCloseModal()
  }

  onSendingEmail (recaptchaResponse) {
    this.setState({sending: true})
    API.post(`/v3/works/${this.props.workId}/share`, { email: this.state.email, content: this.state.message, recaptcha_token: recaptchaResponse })
    .then(() => { this.closeModal() })
    .catch(() => alert('Oops! Something went wrong. Please try again, or contact us at hello@pobble.com.'))
  }

  handleEmailChange (event) {
    this.setState({email: event.target.value})
  }

  handleMessageChange (event) {
    this.setState({message: event.target.value})
  }

  checkCaptcha (e) {
    e.preventDefault()
    this.recaptcha.execute()
  }

  onCaptchaResolved () {
    this.onSendingEmail(this.recaptcha.getResponse())
  }

  render () {
    return (
      <div className='modal-content'>
        <div className='modal-header'>
          <h4 className='modal-title'>Share this work by email</h4>
          <span className='modal__close' onClick={this.closeModal}>
            <FaClose />
          </span>
        </div>
        <form name='editForm' onSubmit={e => this.checkCaptcha(e)}>
          <div className='modal-body'>
            <div className='form-group required'>
              <label htmlFor='email'>To:</label>
              <input id='email' type='email' placeholder='Provide an email address' value={this.state.email} onChange={this.handleEmailChange} className='form-control' required='required' />
            </div>
            <div className='form-group'>
              <label htmlFor='from'>From:</label>
              <input id='from' type='text' value={this.props.userName} className='form-control' disabled />
            </div>
            <div className='form-group'>
              <label htmlFor='subject'>Subject:</label>
              <input id='subject' type='text' value={'Please take a look! ' + this.props.workTitle} className='form-control' disabled />
            </div>
            <div className='form-group required'>
              <label htmlFor='message'>Your message:</label>
              <textarea id='message' value={this.state.message} onChange={this.handleMessageChange} className='form-control' rows='4' required='required' />
              <Recaptcha ref={ref => { this.recaptcha = ref }} sitekey={this.props.captchaToken} onResolved={this.onCaptchaResolved} />
            </div>
          </div>
          <div className='modal-footer'>
            <span className='btn btn-link' onClick={this.closeModal}>Cancel</span>
            <button className='btn btn-primary' type='submit' disabled={this.state.email === '' || this.state.message === '' || this.state.sending}>Send <FaCaretRight /></button>
          </div>
        </form>
      </div>
    )
  }
}

export default WorkShareByEmailModal

WorkShareByEmailModal.propTypes = {
  workId: PropTypes.string,
  onCloseModal: PropTypes.func
}



// WEBPACK FOOTER //
// ./components/work/WorkShareByEmailModal.js